var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-layout-history-template',{attrs:{"isBread":true,"breadHeading":'最近見た物件'},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.viewHistoryReady)?_c('view-history-contents'):_vm._e()]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }